<template>
  <div id="photo_in">
    <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs><a style="color: #888;">> <span style="padding-left: 4px;">{{photobread}}</span></a>
      </Breadcrumb>
    </div>
    <div class="con_all">
      <div class="con_box">
        <div class="photo_box" v-for="(photo,index) in photos" :key="index" v-if="inCurrentPage(index)">
          <div class="photo_box_icon">
            {{photo.memo}}
            <div class="mt10">
              <button type="submit" class="photo_btn">more</button>
            </div>
          </div>
          <a :href="photo.fileUrl" data-lightbox="pages">
            <div class="photo_box_icon2">
              <button type="button" class="view_ph"><i class="fa fa-search" aria-hidden="true"></i></button>
            </div>
          </a>
          <div class="photo_box_pic"><img :src="photo.fileUrl"></div>
        </div>
        <div class="fix"></div>
        <div class="pagination-row text-center ml20">
          <Page :total="photos.length" style="margin-top:20px" :page-size="pagesize" @on-change="changePage"></Page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import "@/../static/js/jquery-1.12.4.js";
import "@/../static/js/lightbox.js";
// import "@/../static/js/photoin.js";　　　//好像用不到的js

import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'photo_in',
  data() {
    return {
      photos: [],
      currentPage: 1,
      pagesize: 12
    };
  },
  props: [
    'outerphoto'
  ],
  created() {
    this.init();
  },
  computed: {
    photobread() {
      for (var i in this.outerphoto) {
        if (this.outerphoto[i].id == this.$route.params.albumId) {
          return this.outerphoto[i].nameCh
          // 英文待處理
        }
      }
    }
  },
  methods: {
    init() {
      this.initPhotos();
    },
    initPhotos() {
      this.getPhotosData();
    },
    getPhotosData() {
      axios.get(API.picture + `?albumId=${this.$route.params.albumId}`)
        .then(response => {
          this.photos = response.data;
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage(index) {
      let currentPage = this.currentPage,
        pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize
    }
  },
}

</script>
<style lang="scss">
@import "/../static/css/lightbox.css";
#photo_in {
  .breadcrumbs {
    display: inline-block;
  }
  .photo_box {
    cursor: default;
  }
}

</style>



// WEBPACK FOOTER //
// PhotoIn.vue?bb1bd00e